import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MessageService, ConfirmationService } from "primeng/api";
import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  Inject, AfterViewInit, ElementRef, ViewChild,
} from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { AlertService } from "@app/_services";
import * as moment from "moment";
import { PrimeNGConfig } from "primeng/api";
import { PropertyService } from "@app/_components/property/property.service";
import { DevelopmentService } from "@app/_components/development";
import { MaintenanceEvent } from "../maintenance-event";
import { MaintenanceEventService } from "../maintenance-event.service";
import { HttpClient } from "@angular/common/http";
import { ActivatedRoute } from "@angular/router";

@Component({
    selector: "app-maintenance-event",
    templateUrl: "./maintenance-event.component.html",
    styleUrls: ["./maintenance-event.component.css"],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class MaintenanceEventComponent implements OnInit, AfterViewInit {
  @ViewChild('emailTemplate', { static: false }) emailTemplate!: ElementRef;
  visibilities: any[]=[];
  constructor(
    private propertyService: PropertyService,
    private developmentService: DevelopmentService,
    private primengConfig: PrimeNGConfig,
    private maintenanceEventService: MaintenanceEventService,
    private alertService: AlertService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private formBuilder: UntypedFormBuilder,
    private activatedRoute: ActivatedRoute,
    private http: HttpClient,
    @Inject(MAT_DIALOG_DATA) data: any
  ) {
    this.formTitle = data.title;
    this.maintenanceEvent = data?.maintenanceEvent;
    this.maintenanceEventList = data?.maintenanceEventList;
    if(this.maintenanceEventList != undefined && this.maintenanceEventList != null && this.maintenanceEventList.length > 0){
      this.maintenanceEvent = this.maintenanceEventList[0];
    }
    this.statuses = maintenanceEventService.statuses;
    this.resolutions = maintenanceEventService.resolutions;
    this.time = maintenanceEventService.time;
    this.visibilities = maintenanceEventService.visibilities;
  }

  @Input() maintenanceEvent: MaintenanceEvent;
  @Output() doAdd = new EventEmitter<any>();
  @Output() doUpdate = new EventEmitter<any>();
  @Output() doDelete = new EventEmitter<any>();

  // data
  maintenanceEventId: number;
  strOrFloor = "floor";
  statuses: any;
  resolutions: any;
  time: any;
  // maintenanceEventShortTermRentalAPIList: MaintenanceEventShortTermRentalAPI[] = [];
  properties: any;
  developments: any;

  // forms
  form1: UntypedFormGroup;
  formLoading = false;
  formAlert: String;
  formTitle: String;

  validationMessages = {
    maintenanceEventId: [],
    name: [
      { type: "required", message: "Required" },
      { type: "minlength", message: "3 characters minimum" },
    ],
    description: [{ type: "required", message: "Required" }],
    impactDesc: [],
    resolutionDesc: [],
    resolution: [],
    opsNotes: [],
    startDate: [{ type: "required", message: "Required" }],
    endDate: [{ type: "required", message: "Required" }],
    startTime: [],
    endTime: [],
    status: [],
    maintenanceEventShortTermRentalAPIList: [{ type: "required", message: "Required" }],
    floorOfProperty: [
      {
        type: "pattern",
        message:
          "Invalid input. Please put floor(s) in comma separated format.",
      },
    ],
    adrBuildingName: [],
    adrComplexName: [],
    developmentId: [{ type: "required", message: "Required" }],
    visibility:[]
  };

  maintenanceEventList: any[] = [];

  ngOnInit() {
    this.fetchProperties();
    this.fetchDevelopments();
    this.primengConfig.ripple = true;
    

    // if we were passed the whole maintenanceEvent object
    if (this.maintenanceEvent) {
      this.maintenanceEventId = this.maintenanceEvent.maintenanceEventId;
      this.formBuild();
      this.fixDates();
      this.form1.patchValue(this.maintenanceEvent);
    }else{
      this.maintenanceEventId = Number(this.activatedRoute.snapshot.params['maintenanceEventId']);
      this.formBuild();
      if(this.maintenanceEventId){
        this.fetchMaintenanceEventById();
      }
    }
  }

  ngAfterViewInit(): void {
    /*// After view is initialized, grab the entire rendered HTML
    const htmlContent = this.emailTemplate.nativeElement.innerHTML;

    // Capture external CSS and inline it
    this.captureExternalStyles(htmlContent).then(inlinedHtml => {
      // Extract form field values and update HTML
      const updatedHtml = this.extractFormValues(inlinedHtml);
      console.log(updatedHtml);
    });*/

  }

  sendEmail(action) {
    const dialogElement = document.querySelector('#emailTemplate') as HTMLElement;
    if (dialogElement) {
      dialogElement.style.position = 'relative';

      this.populateFormFields(dialogElement);  // ✅ Preserve input values
      this.populateIcons(dialogElement);       // ✅ Fix missing icons
      this.makeFieldsReadonly(dialogElement);  // ✅ Make fields readonly
      this.removeButtons(dialogElement);       // ✅ Remove buttons

      const emailHtmlContent = this.getAllStyles() + dialogElement.outerHTML;
      this.sendEmailService(emailHtmlContent, action);
    }
  }

  removeButtons(container: HTMLElement) {
    container.querySelectorAll('button').forEach(button => button.remove());
  }

  makeFieldsReadonly(container: HTMLElement) {
    container.querySelectorAll('input, textarea').forEach((el: HTMLInputElement | HTMLTextAreaElement) => {
      el.setAttribute('readonly', 'true');
    });

    container.querySelectorAll('select').forEach((el: HTMLSelectElement) => {
      el.setAttribute('disabled', 'true');
    });
  }

  populateFormFields(container: HTMLElement) {
    container.querySelectorAll('input, textarea').forEach((el: HTMLInputElement | HTMLTextAreaElement) => {
      el.setAttribute('value', el.value);
    });

    container.querySelectorAll('select').forEach((el: HTMLSelectElement) => {
      const selectedOption = el.options[el.selectedIndex];
      if (selectedOption) {
        selectedOption.setAttribute('selected', 'true');
      }
    });
  }

  populateIcons(container: HTMLElement) {
    container.querySelectorAll('i.pi').forEach((el: HTMLElement) => {
      const iconClass = Array.from(el.classList).find(cls => cls.startsWith('pi-'));
      if (iconClass) {
        const iconMap: { [key: string]: string } = {
          'pi-check': '✔️',
          'pi-times': '❌',
          'pi-info-circle': 'ℹ️',
          'pi-exclamation-triangle': '⚠️',
          'pi-user': '👤'
        };
        el.innerHTML = iconMap[iconClass] || el.innerHTML;
      }
    });
  }

  getAllStyles() {
    let styles = '';

    for (const sheet of Array.from(document.styleSheets)) {
      try {
        for (const rule of Array.from(sheet.cssRules)) {
          styles += rule.cssText + '\n';
        }
      } catch (err) {
        console.warn('Cannot access stylesheet:', err);
      }
    }

    const externalStyles = `
    <link href="https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap" rel="stylesheet">
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/primeicons/6.0.1/primeicons.min.css">
  `;

    return externalStyles + `<style>${styles}</style>`;
  }

  sendEmailService(content: string, action: string) {
    // console.log(content);
    this.maintenanceEventService.sendEmail(content, this.maintenanceEvent).subscribe(res => {
      console.log("property-update SUCCESS: " + JSON.stringify(res));
      this.messageService.add({
        severity: "success",
        summary: "Success",
        detail: 'Email Sent',
      });
      this.maintenanceEvent = res.data.maintenanceEvent;
      window.location.reload();
      if (action === 'add') {
        this.doAdd.emit(this.maintenanceEvent);
      } else {
        this.doUpdate.emit(this.maintenanceEvent);
      }
    });
  }




  // checkDate(today: Date, startDate: Date, endDate: Date): void {
  //   if (today < startDate) {
  //     this.form1.patchValue({
  //       status: "Complete"
  //     });
  //   } else if (today > endDate) {
  //     this.form1.patchValue({
  //       status: "Planned"
  //     });
  //   } else {
  //     this.form1.patchValue({
  //       status: "In-process"
  //     });
  //   }
  // }

  checkDate(today: Date, startDate: Date, endDate: Date): string {
	  
		if (today < startDate) {
		  return "Planned";
		} else if (today > endDate) {
		  return "Complete";
		} else {
		  return "In-process";
		}
	  }

  onFormDelete() {
    console.log("onRowDelete: " + JSON.stringify(event));
    this.confirmationService.confirm({
      message:
        "Are you sure you want to delete Id# " + this.maintenanceEventId + "?",
      header: "Confirm",
      icon: "pi pi-exclamation-triangle",
      accept: () => {
        this.formDelete();
      },
      reject: () => {
        this.messageService.add({
          severity: "info",
          summary: "Canceled",
          detail: "Delete canceled.",
          life: 3000,
        });
      },
    });
  }

  formAdd() {
    try {
      // stop here if form is invalid
      this.form1.markAllAsTouched();
      if (this.form1.invalid) {
        return;
      }
      console.log("property-add post: " + JSON.stringify(this.form1.value));
      const newAPIList = [];
      const currentAPIList =
        this.form1.value.maintenanceEventShortTermRentalAPIList;
      console.log("currentAPIList: ");
      console.log(currentAPIList);
      for (var property of currentAPIList) {
        const newShortTermRentalObject = {
          shortTermRentalId: property.shortTermRentalId,
          propertyCode: property.propertyCode,
          opsNote: "",
        };
        newAPIList.push(newShortTermRentalObject);
      }
      this.form1.value.maintenanceEventShortTermRentalAPIList = newAPIList;
      this.formLoading = true;
      this.maintenanceEventService.add(this.form1.value).subscribe(
        (res: any) => {
          console.log("property-add SUCCESS: " + JSON.stringify(res));
          this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: res.message,
          });
          this.maintenanceEvent = res.data.maintenanceEvent;
         this.doAdd.emit(this.maintenanceEvent);
          // this.sendEmail('add');
        },
        (err: any) => {
          console.log("maintenanceEvent-add FAIL: " + JSON.stringify(err));
          this.alertService.error(err);
        },
        () => {
          this.formLoading = false;
        }
      );
    } catch (error) {
      this.alertService.error(error);
    }
  }

  formUpdate() {
    console.log("maintenanceEvent: " + JSON.stringify(this.form1.value));
    try {
      // stop here if form is invalid
      this.form1.markAllAsTouched();
      if (this.form1.invalid) {
        return;
      }
      this.formLoading = true;

      this.maintenanceEventService.update(this.form1.value).subscribe(
        (res: any) => {
          console.log("property-update SUCCESS: " + JSON.stringify(res));
          this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: res.message,
          });
          this.maintenanceEvent = res.data.maintenanceEvent;
          this.maintenanceEventId = this.maintenanceEvent?.maintenanceEventId;
          this.doUpdate.emit(this.maintenanceEvent);
          // this.maintenanceEvent = res.data.maintenanceEvent;
        //  this.sendEmail('edit');
        },
        (err: any) => {
          console.log("property-update FAIL: " + JSON.stringify(err));
          this.alertService.error(err);
        },
        () => {
          this.formLoading = false;
        }
      );
    } catch (error) {
      console.log("Form Invalid: " + JSON.stringify(error));
      this.alertService.error(error);
    }
  }

  formDelete() {
    try {
      this.maintenanceEventService
        .delete(this.maintenanceEvent.maintenanceEventId)
        .subscribe(
          (res: any) => {
            console.log(
              "maintenanceEvent-delete SUCCESS: " + JSON.stringify(res)
            );
            this.messageService.add({
              severity: "success",
              summary: "Success",
              detail: res.message,
            });
            this.doDelete.emit(this.maintenanceEvent);
          },
          (err: any) => {
            console.log("maintenanceEvent-add FAIL: " + JSON.stringify(err));
            this.alertService.error(err);
          },
          () => {
            this.formLoading = false;
          }
        );
    } catch (error) {
      this.alertService.error(error);
    }
  }

  formBuild() {
    this.form1 = this.formBuilder.group({
      maintenanceEventId: [this.maintenanceEventId],
      name: [
        "",
        Validators.compose([Validators.minLength(3), Validators.required]),
      ],
      description: [],
      impactDesc: [],
      resolutionDesc: [],
      resolution: [],
      opsNotes: [],
      startDate: ['', Validators.required],
      endDate: ['', Validators.required],
      startTime: [],
      endTime: [],
      status: [],
      maintenanceEventShortTermRentalAPIList: ['', Validators.required],
      floorOfProperty: [
        "",
        Validators.compose([
          Validators.pattern("^([1-9][0-9]?|100)(,([1-9][0-9]?|100)){0,}?$"),
        ]),
      ],
      adrBuildingName: [],
      adrComplexName: [],
      developmentId: ['', Validators.required],
      visibility:[]
    });
  }

  fixDates() {
    // create date objects - why can't primeng do this?
    this.maintenanceEvent.startDate = moment(
      this.maintenanceEvent.startDate
    ).toDate();
    this.maintenanceEvent.endDate = moment(
      this.maintenanceEvent.endDate
    ).toDate();
    this.maintenanceEvent.status = this.checkDate(new Date(), this.maintenanceEvent.startDate, this.maintenanceEvent.endDate);
    this.form1.patchValue({
      status: this.maintenanceEvent.status
    });
  }

  fetchProperties() {
		try {
			this.propertyService.propertySummaryForShortData()
				.subscribe(
					res => {
						// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
						this.properties = res.data.properties;
            if(this.maintenanceEvent){
              this.properties.forEach(property => {
                property.maintenanceEventId = this.maintenanceEvent?.maintenanceEventId;
              });
              this.form1.patchValue({
                maintenanceEventShortTermRentalAPIList : this.maintenanceEvent.maintenanceEventShortTermRentalAPIList
              });
            }
					},
					err => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

  fetchMaintenanceEventById() {
		try {
			this.maintenanceEventService.findById(this.maintenanceEventId)
				.subscribe(
					res => {
						// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
						this.maintenanceEvent = res.data.maintenanceEvent;
            if (this.maintenanceEvent) {
              const today = new Date();
              this.checkDate(today, this.maintenanceEvent.startDate, this.maintenanceEvent.endDate);
              this.maintenanceEventId = this.maintenanceEvent.maintenanceEventId;
              this.fixDates();
              this.form1.patchValue(this.maintenanceEvent);
            }
					},
					err => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

  fetchMaintenanceEventByMaintenanceEventId(maintenanceEvent: any) {
		try {
			this.maintenanceEventService.findById(maintenanceEvent.maintenanceEventId)
				.subscribe(
					res => {
						// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
						this.maintenanceEvent = res.data.maintenanceEvent;
            if (this.maintenanceEvent) {
              const today = new Date();
              this.checkDate(today, this.maintenanceEvent.startDate, this.maintenanceEvent.endDate);
              this.maintenanceEventId = this.maintenanceEvent.maintenanceEventId;
              this.fixDates();
              this.form1.patchValue(this.maintenanceEvent);
            }
					},
					err => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

  fetchDevelopments() {
    if (
      !this.developments ||
      this.developments === undefined ||
      this.developments.length < 1
    ) {
      try {
        this.developmentService.getDevelopmentSummary().subscribe(
          (res) => {
            // console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
            this.developments = res.data.developments;
            return this.developments;
          },
          (err) => {
            console.log("Feature-Update FAIL: " + JSON.stringify(err));
            this.alertService.error(err);
          },
          () => {}
        );
      } catch (error) {
        console.log("Form Invalid: " + JSON.stringify(error));
        this.alertService.error(error);
      }
    } else {
      // console.log('properties are ' + this.properties);
      return this.developments;
    }
  }

}
